export default "__VITE_ASSET__882eed49__"